import httpClient from './httpClient';

const baseEndpoint = '/api/shop/item'

const deleteItemById = existingId => {
    return httpClient.delete(`${baseEndpoint}/secure/delete`, { params: { existingId } })
}

const saveItem = request => {
    return httpClient.post(`${baseEndpoint}/secure/save`, request)
}

const updateItem = (request, existingId) => {
    return httpClient.put(`${baseEndpoint}/secure/update`, request, { params: { existingId } })
}

const fetchItemById = id => {
    return httpClient.get(`${baseEndpoint}/`, { params: { id } })
}

const fetchAllItems = (page, pageSize) => {
    return httpClient.get(`${baseEndpoint}/all`, { params: { page, pageSize } })
}

const fetchAllItemsByCategory = (page, pageSize, category) => {
    return httpClient.get(`${baseEndpoint}/all/category`, { params: { page, pageSize, category }})
}

const fetchCategories = () => {
    return httpClient.get(`${baseEndpoint}/categories`)
}


export {
    deleteItemById,
    saveItem,
    updateItem,
    fetchItemById,
    fetchAllItems,
    fetchAllItemsByCategory,
    fetchCategories
}
